import React from 'react';
import dayjs from 'dayjs';
import { Row, Col, Image } from 'antd';
import siteLogo from '@assets/images/logo-text-x.png';

const SecurityReport = ({ reportData, user }) => {
    const [logoError, setLogoError] = React.useState(false);

    console.log("reportData", reportData);

    if (!reportData) return null;

    const companyLogo = logoError
        ? siteLogo
        : (reportData?.guardCompany?.logo?.[0]?.url ||
           reportData?.property?.guardCompany?.logo?.[0]?.url ||
           user?.guardCompany?.logo?.[0]?.url ||
           siteLogo);

    const addressStr = reportData?.address
        ? `${reportData?.address?.streetNumber || ''} ${reportData?.address?.streetName || ''}, ${reportData?.address?.city || ''}, ${reportData?.address?.state || ''} ${reportData?.address?.zip || ''}`.trim()
        : '-';

    const status = (reportData?.status || reportData?.assignedTo?.status || '-').toLowerCase();

    // Status color (Red badge for closed / high priority, matching screenshot)
    let statusBg = '#d9534f';
    let statusColor = '#ffffff';

    if (status.includes('closed') || status.includes('high') || reportData?.level === 3) {
        statusBg = '#c9302c';
        statusColor = '#ffffff';
    } else if (status.includes('pending') || status.includes('low') || reportData?.level === 1) {
        statusBg = '#f0ad4e';
        statusColor = '#ffffff';
    } else if (status.includes('assigned') || status.includes('medium') || reportData?.level === 2) {
        statusBg = '#5cb85c';
        statusColor = '#ffffff';
    }

    const formatDateTime = (dateStr) => {
        if (!dateStr) return '-';
        return dayjs(dateStr).format('ddd MM/DD/YY hh:mm A');
    };

    return (
        <div style={{ backgroundColor: '#ffffff', padding: '20px', width: '100%', fontFamily: 'Gilroy, Arial, sans-serif', boxSizing: 'border-box' }}>
            {/* Header section matching Screenshot 2 */}
            <table style={{ width: '100%', marginBottom: '20px', borderCollapse: 'collapse' }}>
                <tbody>
                    <tr>
                        <td style={{ width: '30%', verticalAlign: 'top' }}>
                            <div style={{ width: '75px', height: '75px', minWidth: '75px', minHeight: '75px' }}>
                                <svg width="75" height="75" viewBox="0 0 75 75" style={{ display: 'block' }}>
                                    <defs>
                                        <clipPath id="companyLogoClip">
                                            <circle cx="37.5" cy="37.5" r="33.5" />
                                        </clipPath>
                                    </defs>
                                    {/* Outer circle border */}
                                    <circle cx="37.5" cy="37.5" r="36.5" fill="#ffffff" stroke="#e0e0e0" strokeWidth="1" />
                                    {/* Inner image cropped to a circle */}
                                    <image
                                        href={companyLogo}
                                        x="4"
                                        y="4"
                                        width="67"
                                        height="67"
                                        preserveAspectRatio="xMidYMid slice"
                                        clipPath="url(#companyLogoClip)"
                                    />
                                </svg>
                                <img
                                    src={companyLogo}
                                    alt="Fallback Trigger"
                                    style={{ display: 'none' }}
                                    onError={() => {
                                        if (!logoError) {
                                            setLogoError(true);
                                        }
                                    }}
                                />
                            </div>
                        </td>
                        <td style={{ width: '40%', textAlign: 'center', verticalAlign: 'middle' }}>
                            <h1 style={{ fontSize: '32px', fontWeight: '400', color: '#777777', margin: '0', letterSpacing: '0.5px' }}>
                                Security Report
                            </h1>
                            <p style={{ fontSize: '15px', color: '#555555', margin: '4px 0 0 0', fontWeight: '500' }}>
                                Guards Connect
                            </p>
                        </td>
                        <td style={{ width: '30%', textAlign: 'right', verticalAlign: 'top' }}>
                            <span style={{ fontSize: '24px', fontWeight: 'normal', color: '#777777' }}>
                                #{reportData?.reportNumber || '-'}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* Two Column Grid */}
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                <tbody>
                    <tr>
                        {/* Left Column */}
                        <td style={{ width: '48%', verticalAlign: 'top', paddingRight: '2%' }}>
                            {/* Issue Type */}
                            <div style={{ marginBottom: '14px' }}>
                                <label style={{ display: 'block', fontSize: '12px', color: '#888888', fontWeight: '600', marginBottom: '4px', textTransform: 'none' }}>Issue Type</label>
                                <div style={{ backgroundColor: '#f2f2f2', padding: '8px 12px', fontSize: '13px', color: '#333333', borderRadius: '2px' }}>
                                    {reportData?.incidentType?.name || 'Alarm Response'}
                                </div>
                            </div>

                            {/* Status */}
                            <div style={{ marginBottom: '14px' }}>
                                <label style={{ display: 'block', fontSize: '12px', color: '#888888', fontWeight: '600', marginBottom: '4px', textTransform: 'none' }}>Status</label>
                                <div style={{
                                    backgroundColor: statusBg,
                                    color: statusColor,
                                    padding: '8px 12px',
                                    fontSize: '13px',
                                    fontWeight: 'bold',
                                    borderRadius: '2px',
                                    display: 'inline-block',
                                    minWidth: '100px',
                                    textAlign: 'center'
                                }}>
                                    {reportData?.status || reportData?.assignedTo?.status || 'Closed'}
                                </div>
                            </div>

                            {/* Property */}
                            <div style={{ marginBottom: '14px' }}>
                                <label style={{ display: 'block', fontSize: '12px', color: '#888888', fontWeight: '600', marginBottom: '4px', textTransform: 'none' }}>Property</label>
                                <div style={{ backgroundColor: '#f2f2f2', padding: '8px 12px', fontSize: '13px', color: '#333333', borderRadius: '2px', lineHeight: '1.4' }}>
                                    <div style={{ fontWeight: 'bold' }}>{reportData?.property?.name || '-'}</div>
                                    <div>{addressStr}</div>
                                </div>
                            </div>

                            {/* Location */}
                            <div style={{ marginBottom: '14px' }}>
                                <label style={{ display: 'block', fontSize: '12px', color: '#888888', fontWeight: '600', marginBottom: '4px', textTransform: 'none' }}>Location</label>
                                <div style={{ backgroundColor: '#f2f2f2', padding: '8px 12px', fontSize: '13px', color: '#333333', borderRadius: '2px' }}>
                                    {reportData?.floor || reportData?.unit ? `Floor: ${reportData?.floor || '-'} / Unit: ${reportData?.unit || '-'}` : 'Default'}
                                </div>
                            </div>

                            {/* Reported By */}
                            <div style={{ marginBottom: '14px' }}>
                                <label style={{ display: 'block', fontSize: '12px', color: '#888888', fontWeight: '600', marginBottom: '4px', textTransform: 'none' }}>Reported By</label>
                                <div style={{ backgroundColor: '#f2f2f2', padding: '8px 12px', fontSize: '13px', color: '#333333', borderRadius: '2px' }}>
                                    {reportData?.reportedBy?.firstName
                                        ? `${reportData?.reportedBy?.firstName} ${reportData?.reportedBy?.lastName || ''}`
                                        : '-'}
                                </div>
                            </div>
                        </td>

                        {/* Right Column */}
                        <td style={{ width: '50%', verticalAlign: 'top' }}>
                            {/* Issue Timeline */}
                            <div style={{ marginBottom: '14px' }}>
                                <label style={{ display: 'block', fontSize: '12px', color: '#888888', fontWeight: '600', marginBottom: '6px', textAlign: 'right' }}>Issue Timeline</label>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                                    <tbody>
                                        <tr style={{ backgroundColor: '#f5f5f5' }}>
                                            <td style={{ padding: '6px 10px', color: '#888888', width: '30%' }}>Created</td>
                                            <td style={{ padding: '6px 10px', color: '#333333', width: '45%' }}>{formatDateTime(reportData?.createdDate)}</td>
                                            <td style={{ padding: '6px 10px', color: '#333333', textAlign: 'right', fontWeight: 'bold' }}>{reportData?.reportedBy?.firstName || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '6px 10px', color: '#888888' }}>Assigned To</td>
                                            <td style={{ padding: '6px 10px', color: '#333333' }}>{formatDateTime(reportData?.assignedDate || reportData?.createdDate)}</td>
                                            <td style={{ padding: '6px 10px', color: '#333333', textAlign: 'right', fontWeight: 'bold' }}>{reportData?.assignedTo?.firstName || '-'}</td>
                                        </tr>
                                        <tr style={{ backgroundColor: '#f5f5f5' }}>
                                            <td style={{ padding: '6px 10px', color: '#888888' }}>Acknowledged</td>
                                            <td style={{ padding: '6px 10px', color: '#333333' }}>{formatDateTime(reportData?.acknowledgedDate)}</td>
                                            <td style={{ padding: '6px 10px', color: '#333333', textAlign: 'right', fontWeight: 'bold' }}>{reportData?.assignedTo?.firstName || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '6px 10px', color: '#888888' }}>Arrived At</td>
                                            <td style={{ padding: '6px 10px', color: '#333333' }}>{formatDateTime(reportData?.assignedDate)}</td>
                                            <td style={{ padding: '6px 10px', color: '#333333', textAlign: 'right', fontWeight: 'bold' }}>{reportData?.assignedTo?.firstName || '-'}</td>
                                        </tr>
                                        <tr style={{ backgroundColor: '#f5f5f5' }}>
                                            <td style={{ padding: '6px 10px', color: '#888888' }}>Closed</td>
                                            <td style={{ padding: '6px 10px', color: '#333333' }}>{status.includes('closed') ? formatDateTime(reportData?.acknowledgedDate || reportData?.assignedDate) : '-'}</td>
                                            <td style={{ padding: '6px 10px', color: '#333333', textAlign: 'right', fontWeight: 'bold' }}>{status.includes('closed') ? (reportData?.assignedTo?.firstName || '-') : '-'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Additional Details */}
                            <div style={{ marginTop: '20px' }}>
                                <label style={{ display: 'block', fontSize: '12px', color: '#888888', fontWeight: '600', marginBottom: '6px', textAlign: 'right' }}>Additional Details</label>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', backgroundColor: '#f5f5f5' }}>
                                    <tbody>
                                        <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                                            <td style={{ padding: '6px 10px', color: '#888888', width: '35%' }}>Assigned By</td>
                                            <td style={{ padding: '6px 10px', color: '#333333', fontWeight: 'bold' }}>
                                                {reportData?.assignedBy?.first_name
                                                    ? `${reportData?.assignedBy?.first_name} ${reportData?.assignedBy?.last_name || ''}`
                                                    : '-'}
                                            </td>
                                        </tr>
                                        <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                                            <td style={{ padding: '6px 10px', color: '#888888' }}>Reported Address</td>
                                            <td style={{ padding: '6px 10px', color: '#333333' }}>{addressStr}</td>
                                        </tr>
                                        <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                                            <td style={{ padding: '6px 10px', color: '#888888' }}>Reported Unit</td>
                                            <td style={{ padding: '6px 10px', color: '#333333' }}>{reportData?.unit || '-'}</td>
                                        </tr>
                                        <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                                            <td style={{ padding: '6px 10px', color: '#888888' }}>Problem Address</td>
                                            <td style={{ padding: '6px 10px', color: '#333333' }}>{addressStr}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '6px 10px', color: '#888888' }}>Problem Unit</td>
                                            <td style={{ padding: '6px 10px', color: '#333333' }}>{reportData?.unit || '-'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* Notes Section */}
            {(reportData?.notes || reportData?.description) && (
                <div style={{ marginTop: '20px' }}>
                    <label style={{ display: 'block', fontSize: '12px', color: '#888888', fontWeight: '600', marginBottom: '6px' }}>Notes</label>
                    <div style={{ backgroundColor: '#f5f5f5', padding: '12px 16px', borderRadius: '2px', fontSize: '13px', color: '#333333' }}>
                        <div style={{ fontSize: '11px', color: '#888888', marginBottom: '6px', fontWeight: '600' }}>
                            {formatDateTime(reportData?.acknowledgedDate || reportData?.createdDate)} - {reportData?.assignedTo?.firstName || reportData?.reportedBy?.firstName || 'System'}
                        </div>
                        <div style={{ whitespace: 'pre-wrap', lineHeight: '1.5' }}>
                            {reportData?.notes || reportData?.description}
                        </div>
                    </div>
                </div>
            )}

            {/* Photos Section */}
            {(() => {
                const attachmentsList = reportData?.incidentAttachments ||
                    reportData?.attachments ||
                    reportData?.media ||
                    reportData?.images ||
                    reportData?.incident_attachments ||
                    [];

                console.log("SecurityReport raw reportData:", reportData);
                console.log("SecurityReport resolved attachmentsList:", attachmentsList);

                // const photoAttachments = attachmentsList.filter(attachment => {
                //     const url = attachment?.url || attachment?.fileUrl || attachment?.file_url || (typeof attachment === 'string' ? attachment : null);
                //     if (!url) return false;
                //     const format = (attachment?.format || '').toLowerCase();
                //     const isVideo = format === 'mp4' || url.split('?')[0]?.toLowerCase().endsWith('.mp4');
                //     return isVideo;
                // });

                // if (photoAttachments.length === 0) return null;

                return (
                    <div style={{ marginTop: '25px' }}>
                        <label style={{ display: 'block', fontSize: '12px', color: '#888888', fontWeight: '600', marginBottom: '10px' }}>
                            Photos
                        </label>
                        <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '10px 0', margin: '0 -10px' }}>
                            <tbody>
                                {Array.from({ length: Math.ceil(attachmentsList.length / 4) }).map((_, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {Array.from({ length: 4 }).map((_, colIndex) => {
                                            const itemIndex = rowIndex * 4 + colIndex;
                                            const attachment = attachmentsList[itemIndex];
                                            if (!attachment) {
                                                return <td key={colIndex} style={{ width: '25%' }} />;
                                            }
                                            const url = attachment?.url || attachment?.fileUrl || attachment?.file_url || (typeof attachment === 'string' ? attachment : null);
                                            return (
                                                <td key={colIndex} style={{ width: '25%', verticalAlign: 'top', padding: '0 0 10px 0' }}>
                                                    <div style={{ border: '1px solid #e0e0e0', padding: '2px', backgroundColor: '#ffffff', borderRadius: '2px' }}>
                                                        <img
                                                            src={url}
                                                            alt={`Attachment ${itemIndex + 1}`}
                                                            style={{ width: '100%', height: 'auto', display: 'block', maxHeight: '150px', objectFit: 'cover' }}
                                                        />
                                                    </div>
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                );
            })()}
        </div>
    );
};

export default SecurityReport;
